//
//      apiV1.js
//      Stage Vault
//
//      Created by AI Assistant on 2024-05-02.
//      Provides helpers for building API V1 URLs.
//

// Returns the API base url using the build-time environment configuration.
// The host must be provided via `API_HOSTNAME` during the Vite build.
export const v1BaseUrl = `https://${import.meta.env.API_HOSTNAME}/v1/`;

export function imageUrl(guid) {
        return v1BaseUrl + "content/image?id=" + guid;
}

// Gated streaming proxy for show-extras images and PDFs. Requires an
// authenticated session and that the user is entitled to the parent show.
export function fileUrl(guid) {
        return v1BaseUrl + "content/file?id=" + guid;
}
